if (!customElements.get('ls-dislike-picker')) {
  customElements.define(
    'ls-dislike-picker',
    class LsDislikePicker extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.maxSelections = Number(this.dataset.maxSelections) || 3;
        this.options = Array.from(this.querySelectorAll('[data-dislike-option]'));
        this.propertyInput = this.querySelector('[data-dislike-property]');
        this.summary = this.querySelector('[data-dislike-summary]');
        this.count = this.querySelector('[data-dislike-count]');
        this.error = this.querySelector('[data-dislike-error]');

        this.options.forEach((option) => {
          option.addEventListener('change', () => this.handleChange(option));
        });

        this.update();
      }

      handleChange(changedOption) {
        const selectedOptions = this.options.filter((option) => option.checked);

        if (selectedOptions.length > this.maxSelections) {
          changedOption.checked = false;
          this.error.textContent = this.dataset.limitError;
          this.error.hidden = false;
        } else {
          this.error.textContent = '';
          this.error.hidden = true;
        }

        this.update();
      }

      update() {
        const selectedLabels = this.options.filter((option) => option.checked).map((option) => option.value);
        const selectedCount = selectedLabels.length;

        this.propertyInput.value = selectedLabels.join(', ');
        this.propertyInput.disabled = selectedCount === 0;
        this.summary.textContent = selectedCount > 0 ? selectedLabels.join(', ') : this.dataset.emptyLabel;
        this.summary.title = selectedCount > 0 ? selectedLabels.join(', ') : '';
        this.count.textContent = this.dataset.countTemplate
          .replace('__COUNT__', selectedCount)
          .replace('__MAX__', this.maxSelections);
      }
    },
  );
}
